import { Helmet } from "react-helmet-async";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import Features from "@/components/landing/Features";
import Trust from "@/components/landing/Trust";
import HelpHub from "@/components/landing/HelpHub";
import Footer from "@/components/landing/Footer";

const Index = () => {
  return (
    <div className="min-h-screen">
      <Helmet>
        <title>NextInvoice – Modulare ERP-Software für KMU & Handwerk</title>
        <meta name="description" content="E-Rechnung, CRM, Lager, Buchhaltung – modular kombinierbar. GoBD- und ZUGFeRD-konform. 30 Tage gratis testen, Made in Germany." />
        <link rel="canonical" href="https://nxtinvoice.de/" />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "NextInvoice",
          "url": "https://nxtinvoice.de",
          "description": "Modulare Geschäftssoftware für KMU – Rechnungen, CRM, Lager, Personal und mehr.",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Hauptstraße 56",
            "addressLocality": "Neugersdorf",
            "postalCode": "02727",
            "addressRegion": "Sachsen",
            "addressCountry": "DE"
          },
          "contactPoint": [
            { "@type": "ContactPoint", "telephone": "+4915565350880", "contactType": "sales", "availableLanguage": "German" },
            { "@type": "ContactPoint", "email": "support@nxtinvoice.de", "contactType": "customer support", "availableLanguage": "German" }
          ]
        })}</script>
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "WebSite",
          "name": "NextInvoice",
          "url": "https://nxtinvoice.de",
          "inLanguage": "de-DE"
        })}</script>
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "SiteNavigationElement",
          "name": ["Preise", "Konfigurator", "Branchen", "Über uns"],
          "url": [
            "https://nxtinvoice.de/preise",
            "https://nxtinvoice.de/konfigurator",
            "https://nxtinvoice.de/branchen",
            "https://nxtinvoice.de/ueber-uns"
          ]
        })}</script>
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "SoftwareApplication",
          "name": "NextInvoice",
          "operatingSystem": "Web",
          "applicationCategory": "BusinessApplication",
          "url": "https://nxtinvoice.de",
          "description": "Modulare Geschäftssoftware für KMU – Rechnungen, CRM, Lager, Buchhaltung, Personal und mehr.",
          "offers": [
            { "@type": "Offer", "name": "Starter", "price": "29", "priceCurrency": "EUR", "url": "https://nxtinvoice.de/preise" },
            { "@type": "Offer", "name": "Professional", "price": "79", "priceCurrency": "EUR", "url": "https://nxtinvoice.de/preise" },
            { "@type": "Offer", "name": "Business", "price": "149", "priceCurrency": "EUR", "url": "https://nxtinvoice.de/preise" }
          ]
        })}</script>
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "Was ist NextInvoice?",
              "acceptedAnswer": { "@type": "Answer", "text": "NextInvoice ist eine modulare Geschäftssoftware für Selbstständige und KMU. Rechnungen, CRM, Lager, Buchhaltung und Personal lassen sich frei kombinieren – ganz nach Bedarf." }
            },
            {
              "@type": "Question",
              "name": "Wie funktioniert das Modul-Baukasten-Prinzip?",
              "acceptedAnswer": { "@type": "Answer", "text": "Jeder Plan enthält ein Punkte-Budget. Module kosten 1–3 Punkte, je nach Umfang. Sie kombinieren genau die Module, die Sie brauchen, und erweitern flexibel." }
            },
            {
              "@type": "Question",
              "name": "Kann ich NextInvoice kostenlos testen?",
              "acceptedAnswer": { "@type": "Answer", "text": "Ja. Sie testen NextInvoice 30 Tage kostenlos – ohne Angabe von Kreditkartendaten und ohne automatische Verlängerung." }
            },
            {
              "@type": "Question",
              "name": "Wo werden die Daten gespeichert?",
              "acceptedAnswer": { "@type": "Answer", "text": "Alle Daten werden DSGVO-konform auf deutschen Servern verarbeitet. SSL-verschlüsselte Übertragung ist Standard." }
            },
            {
              "@type": "Question",
              "name": "Was kostet NextInvoice?",
              "acceptedAnswer": { "@type": "Answer", "text": "Ab 29 € / Monat (Starter, 6 Punkte). Professional 79 € / Monat (12 Punkte), Business 149 € / Monat (20 Punkte). Bei jährlicher Zahlung sparen Sie 15 %." }
            },
            {
              "@type": "Question",
              "name": "Für welche Branchen eignet sich NextInvoice?",
              "acceptedAnswer": { "@type": "Answer", "text": "Für Agenturen, Handwerk, Handel, Logistik, IT-Dienstleister und Gesundheits-/Therapieberufe – mit fertigen Branchen-Setups als Startpunkt." }
            }
          ]
        })}</script>
      </Helmet>
      <Header />
      <main>
        <Hero />
        <Features />
        <Trust />
        <HelpHub />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
